import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const warehouseApi = factory.get("warehouse");

const initialState = {
  warehouses: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      page: 0,
      take: 25,
      search: "",
      is_ftth:1
    },
    assignManagersDialog: {
      open: false,
      selectedWarehouse: null,
      loading: false,
    },
  },
};

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.warehouses.data = payload.data;
      state.warehouses.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.warehouses.filters = {
        ...state.warehouses.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.warehouses.filters = initialState.warehouses.filters;
    },
    setFiltersDialog: (state) => {
      state.warehouses.dialog = !state.warehouses.dialog;
    },
    toggleAssignManagersDialog: (state, { payload }) => {
      state.warehouses.assignManagersDialog.open =
        !state.warehouses.assignManagersDialog.open;
      state.warehouses.assignManagersDialog.selectedWarehouse = payload || null;
    },
    setAssignManagersLoading: (state, { payload }) => {
      state.warehouses.assignManagersDialog.loading = payload;
    },
  },
});

export const {
  setData,
  setLoading,
  setFilters,
  resetFilters,
  setFiltersDialog,
  toggleAssignManagersDialog,
  setAssignManagersLoading,
} = warehouseSlice.actions;

export default warehouseSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("warehouses"));
    const filters = getState().warehouse.warehouses.filters;
    const res = await warehouseApi.index(filters);
    dispatch(setData(res.data));
    dispatch(setLoading("warehouses"));
  } catch (err) {
    dispatch(setLoading("warehouses"));
    throw new Error(err);
  }
};

const checkSn = (data) => async (dispatch) => {
  try {
    const res = await warehouseApi.checkSn(data);
    return res.data.data;
  } catch (err) {
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      }),
    );
    throw new Error(err);
  }
};

const assignManagers = (store_id, manager_ids) => async (dispatch) => {
  try {
    dispatch(setAssignManagersLoading(true));
    await warehouseApi.assignManagers(store_id, { manager_ids });
    dispatch(
      showNotification({
        type: "success",
        message: "تم تعيين المدراء بنجاح",
      }),
    );
    dispatch(toggleAssignManagersDialog());
    dispatch(index());
    dispatch(setAssignManagersLoading(false));
  } catch (err) {
    dispatch(setAssignManagersLoading(false));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.message || "حدث خطأ ما",
      }),
    );
    throw new Error(err);
  }
};

export const Warehouse = {
  index,
  checkSn,
  assignManagers,
};
